import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'inside-out/components/shared/link';

import { titleStyle, listStyle } from './styles';

const FileAttachmentsComponent = ({ title, attachments }) => {
	if (!attachments || attachments.length === 0) return null;

	return (
		<section data-component="FileAttachments">
			<h1 className={titleStyle}>{title}</h1>
			<ul className={listStyle}>
				{attachments.map((attachment, i) => (
					<li key={i}>
						<Link to={attachment.file}>{attachment.button_text || attachment.file}</Link>
					</li>
				))}
			</ul>
		</section>
	);
};

FileAttachmentsComponent.propTypes = {
	title: PropTypes.string,
	attachments: PropTypes.array,
};

export const FileAttachments = FileAttachmentsComponent;



// WEBPACK FOOTER //
// ./src/components/shared/fileAttachments/component.js